var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type=='delete')?_c('Delete',_vm._g(_vm._b({},'Delete',_vm.$attrs,false),_vm.$listeners)):_c('Common',_vm._g(_vm._b({attrs:{"type":_vm.type}},'Common',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-aad40fd4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/button/main.vue
// module id = 181
// module chunks = 0